module.exports = "https://cdn.hellotech.com/client-assets/security_cameras_tablet_2a4489e680b24a5713ab5d66a4fffcbd.png";